// Copied from ember app
export function getOsVersion() {
  const start = window.navigator.appVersion.indexOf('(') + 1;
  const end = window.navigator.appVersion.indexOf(')');

  if (start && end) {
    const version = window.navigator.appVersion.substring(start, end);
    return version.replace(/[^\d]*([\d]?[\d]?(\.|_)?[\d]?[\d]?(\.|_)?[\d]?[\d])[\s\S]*/, '$1').replace(/_/g, '.');
  } else {
    return window.navigator.appVersion;
  }
}
